import { render, staticRenderFns } from "./pagination-bar.component.vue?vue&type=template&id=322bbf06&scoped=true"
import script from "./pagination-bar.component.vue?vue&type=script&lang=ts"
export * from "./pagination-bar.component.vue?vue&type=script&lang=ts"
import style0 from "./pagination-bar.component.vue?vue&type=style&index=0&id=322bbf06&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "322bbf06",
  null
  
)

export default component.exports